import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const getTreeTable = catchAsync(
  async (
    currentLang,
    companyName = '',
    from_date,
    to_date,
    fiscal_year = ''
  ) => {
    const { data } = await axiosInstance.get(
      // `/api/method/technoerp.services.get_report?report_name=Stock Ledger&filters={"company":"${companyName}","from_date":"2024-10-08","to_date":"2024-11-08","valuation_field_type":"Currency"}&_lang=${currentLang}&ignore_prepared_report=true&_=1731064939081`
      `/api/method/technoerp.services.get_report?report_name=Trial Balance&filters={"company":"${companyName}","fiscal_year":"${fiscal_year}","from_date":"${from_date}","to_date":"${to_date}","with_period_closing_entry":1,"include_default_book_entries":1,"show_net_values":1}&ignore_prepared_report=false&is_tree=true&parent_field=parent_account&are_default_filters=false&_=1732881135796&_lang=${currentLang}`
    );
    return data;
  }
);
export const getProfitAndLoss = catchAsync(
  async (
    currentLang,
    companyName = '',
    from_date,
    to_date,
    fiscal_year = ''
  ) => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.get_report?report_name=Profit and Loss Statement&filters={"company":"${companyName}","filter_based_on":"Fiscal Year","period_start_date":"${from_date}","period_end_date":"${to_date}","from_fiscal_year":"${fiscal_year}","to_fiscal_year":"${fiscal_year}","periodicity":"Yearly","include_default_book_entries":1}&is_tree=true&are_default_filters=false&_=1732881135819&_lang=${currentLang}&parent_field=parent_account`
    );
    return data;
  }
);
export const getCashFlow = catchAsync(
  async ({
    currentLang,
    companyName = '',
    period_start_date,
    period_end_date,
    from_fiscal_year,
    to_fiscal_year,
    cost_center,
  }) => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.get_report?report_name=Cash Flow&filters={"company":"${companyName}","filter_based_on":"Fiscal Year","period_start_date":"${period_start_date}","period_end_date":"${period_end_date}","from_fiscal_year":"${from_fiscal_year}","to_fiscal_year":"${to_fiscal_year}","periodicity":"Yearly","cost_center":${
        cost_center ? cost_center : '[]'
      },"project":[],"include_default_book_entries":1}&ignore_prepared_report=false&are_default_filters=false&_=1732881135830&_lang=${currentLang}&is_tree=true&parent_field=parent_account`
    );
    return data;
  }
);
